import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
} from "@mui/material";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import SecurityIcon from "@mui/icons-material/Security";

const BankDetails = ({ bank, bankDetails, updatedEmandateDetails }) => {
  console.log("bank data on bank page ", bankDetails);
  // console.log("mandateId on bank page ", mandateId);
  // console.log("updatedEmandateDetails on bank page ", updatedEmandateDetails);

  const [editOpen, setEditOpen] = useState(false);
  const [formData, setFormData] = useState({
    accountNumber: "",
    confirmAccountNumber: "",
    ifscCode: "",
  });

  const bankData =
    bankDetails?.bankDetails ||
    (updatedEmandateDetails?.length > 0
      ? updatedEmandateDetails[0]?.bankAccountDetails
      : null);
  // console.log("bank data--->", bankData);

  const maskedAccount = "**** " + bankData?.accountNumber.slice(-4);

  return (
    <>
      {/* CARD */}
      <div
        className="bank-card"
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 20,
          boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
          width: "100%",
          maxWidth: "600px", // Limit max width for better scaling on desktop
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        {/* Header */}
        <div
          className="bank-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E0E0E0",
            paddingBottom: 12,
            marginBottom: 20,
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <AccountBalanceIcon
              sx={{
                color: "#1976D2",
                fontSize: "2rem", // Default size for larger screens
                "@media (max-width: 768px)": {
                  fontSize: "2.5rem", // Larger size for mobile
                },
              }}
            />
            <span style={{ fontSize: 16, fontWeight: 600 }}>
              Bank Account Details
            </span>
          </div>

          {/* <Button
            variant="outlined"
            size="small"
            startIcon={<EditIcon />}
            onClick={() => setEditOpen(true)}
            sx={{
              textTransform: "none",
              borderRadius: 8,
              fontSize: 10,
              fontWeight: 600,
            }}
            className="bank-edit-btn"
          >
            Update Details
          </Button> */}
        </div>

        {/* Bank Info */}
        <div
          className="bank-info"
          style={{
            display: "flex",
            gap: 20,
            width: "100%",
            boxSizing: "border-box",
            flexWrap: "wrap", // Allow wrapping to prevent overflow
          }}
        >
          {/* ICON */}
          <div
            className="bank-icon"
            style={{
              width: 56,
              height: 56,
              borderRadius: 12,
              background: "#0D47A1",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <AccountBalanceIcon sx={{ color: "#fff", fontSize: 30 }} />
          </div>

          {/* DETAILS */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            {" "}
            {/* Increased minWidth for better spacing */}
            <div
              className="bank-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)", // Use 2 columns instead of 4 for better spacing
                gap: 20, // Increased gap between items
                fontSize: 14, // Adjust font size for better readability
              }}
            >
              <div>
                <div style={{ color: "#757575" }}>Account Number</div>
                <strong>{maskedAccount || "N/A"}</strong>
              </div>
              <div>
                <div style={{ color: "#757575" }}>IFSC Code</div>
                <strong>
                  {bankData?.ifsc
                    ? bankData?.ifsc
                    : bankData?.ifscCode || "N/A"}
                </strong>
              </div>
              <div>
                <div style={{ color: "#757575" }}>Account Type</div>
                <strong>{bankData?.accountType || "N/A"}</strong>
              </div>
              <div>
                <div style={{ color: "#757575" }}>Account Holder</div>
                <strong>
                  {bankData?.accountHolderName
                    ? bankData?.accountHolderName
                    : bankData?.nameAsPerPan || "N/A"}
                </strong>
              </div>
            </div>
          </div>
        </div>

        {/* Security Note */}
        <div
          style={{
            marginTop: 20,
            padding: "14px 16px",
            background: "#E3F2FD",
            borderRadius: 10,
            display: "flex",
            gap: 12,
            alignItems: "flex-start",
          }}
        >
          <SecurityIcon sx={{ color: "#1565C0", marginTop: 2 }} />
          <span style={{ fontSize: 13, color: "#1565C0" }}>
            Your bank details are securely stored and encrypted. Only partial
            account information is displayed for security.
          </span>
        </div>
      </div>

      {/* Edit Dialog */}
      <Dialog
        open={editOpen}
        onClose={() => setEditOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 600,
            fontSize: 16,
          }}
        >
          Update Bank Details
          <IconButton onClick={() => setEditOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 20,
              paddingTop: 12,
            }}
          >
            <TextField
              label="New Account Number"
              fullWidth
              value={formData.accountNumber}
              onChange={(e) =>
                setFormData({ ...formData, accountNumber: e.target.value })
              }
            />
            <TextField
              label="Confirm Account Number"
              fullWidth
              value={formData.confirmAccountNumber}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  confirmAccountNumber: e.target.value,
                })
              }
            />
            <TextField
              label="IFSC Code"
              fullWidth
              value={formData.ifscCode}
              onChange={(e) =>
                setFormData({ ...formData, ifscCode: e.target.value })
              }
            />

            <div
              style={{
                background: "#FFF3E0",
                padding: "12px 16px",
                borderRadius: 8,
                fontSize: 13,
                color: "#E65100",
              }}
            >
              <strong>Note:</strong> Changing bank details will require
              re-verification of your mandate. This may take 2–3 business days.
            </div>
          </div>
        </DialogContent>

        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button
            onClick={() => setEditOpen(false)}
            sx={{ fontWeight: 600, fontSize: 10 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ bgcolor: "#1565C0", fontWeight: 600, fontSize: 10 }}
          >
            Submit for Verification
          </Button>
        </DialogActions>
      </Dialog>

      {/* 🔽 MOBILE FIX */}
      <style>{`
        @media (max-width: 768px) {
          .bank-info {
            flex-direction: column !important;
            align-items: flex-start !important;
          }

          .bank-grid {
            grid-template-columns: 1fr !important;
          }

          .bank-edit-btn {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default BankDetails;
